/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Gawds, GawdsInterface } from "../Gawds";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "string",
        name: "baseTokenURI_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "maxSupply_",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "price_",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    name: "BaseURILocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    name: "SaleState",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "baseURILocked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "calculatePrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lockBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "maxPresaleGawds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxStaffGawds",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "maxSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "presaleGawdsMintCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "recipients",
        type: "address[]",
      },
    ],
    name: "presaleMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "_data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "saleStarted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseTokenURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "staffGawdsMintCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "count",
        type: "uint256",
      },
    ],
    name: "staffMint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "staffVaultAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "startSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stopSale",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "summonCount",
        type: "uint256",
      },
    ],
    name: "summon",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "tokenOfOwnerByIndex",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
];

const _bytecode =
  "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";

type GawdsConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: GawdsConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Gawds__factory extends ContractFactory {
  constructor(...args: GawdsConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Gawds";
  }

  override deploy(
    name_: string,
    symbol_: string,
    baseTokenURI_: string,
    maxSupply_: BigNumberish,
    price_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Gawds> {
    return super.deploy(
      name_,
      symbol_,
      baseTokenURI_,
      maxSupply_,
      price_,
      overrides || {}
    ) as Promise<Gawds>;
  }
  override getDeployTransaction(
    name_: string,
    symbol_: string,
    baseTokenURI_: string,
    maxSupply_: BigNumberish,
    price_: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      baseTokenURI_,
      maxSupply_,
      price_,
      overrides || {}
    );
  }
  override attach(address: string): Gawds {
    return super.attach(address) as Gawds;
  }
  override connect(signer: Signer): Gawds__factory {
    return super.connect(signer) as Gawds__factory;
  }
  static readonly contractName: "Gawds";

  public readonly contractName: "Gawds";

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GawdsInterface {
    return new utils.Interface(_abi) as GawdsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Gawds {
    return new Contract(address, _abi, signerOrProvider) as Gawds;
  }
}
